module.exports = __webpack_public_path__ + "img/3-Frontline-Home-Page-MVP.a9732b7f.png";